import classNames from 'classnames';

// Partials
import Loader from '/views/partials/loader';

export const Section = ({ className, children, loading }) => {
	return (
		<div
			className={classNames('section', 'layout-sidemenu-section', 'loader-container', className)}
		>
			<Loader solid loading={!!loading} />
			{children}
		</div>
	);
};

export default Section;
